import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    height: '90%'
  },
  header: {
    marginBottom: theme.spacing(6)
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'baseline'
  },
  modalHeader: {
    fontSize: 40,
    fontWeight: 300
  },
  totalContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  totalWord: {
    marginLeft: theme.spacing(2),
    color: theme.colorPalette.beige_75,
    fontSize: 10,
    fontWeight: 600
  },
  totalValue: {
    color: theme.colorPalette.green_75,
    fontSize: 10,
    fontWeight: 600,
    marginLeft: theme.spacing(2)
  },
  openAllImagesButton: {
    fontSize: 14,
    fontWeight: 600,
    padding: 0
  },
  reviewImagesIcon: {
    marginLeft: theme.spacing(2)
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: theme.spacing(4),
    textAlign: 'center'
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: 'auto'
  },
  closeBtn: {
    padding: theme.spacing(1, 2),
    width: 75,
    height: 36
  }
}));

export default useStyles;
